import React, { useEffect, useState, useContext } from "react";
import "./ConcessionaireDashboard.css";
import { compareDateWiseData, getCurrentWeekDate, getJsonData, getLastNDayArr, numberWithCommas } from "../../service/utilService";
import { getConsessionerChartData, getTransactionData, getTransactionDateWiseData, getRejectionByReasoneData, getTranscationTrendByStatusData, getTranscationVsViolationsData, 
  getTranscationTrendByTimeSlotData, getViolationPendingDueData, getTransactionAmountData, getTransactionAmountDateWiseData, getPlaza, getLastThreeDiscountFiles, getLastThreeBTLFiles, 
  getLastThreeTollFiles, getTransactionTrendByTimeSlotData, fetchChargeBackPendingDueData, getTransactionVsViolationsData, getTransactionTrendByStatusData, getTransactionExceptionResponseData,
  getTransactionResponseData, getAckNackFilesData, getLaneWiseTransactionData, getINITFileData, getCashManualTransactionData } from "../../common/apiService";

import MultiSelect from "../../common/MultiSelect";
import TransactionBlock from "./TransactionBlock";
import moment from "moment";
import SelectSearch, { fuzzySearch } from "react-select-search";
import LineChartComp from "./LineChartComp";
import ViolationsChargebackBlock from "./ViolationsChargebackBlock";
import TransactionTrendChart from "./TransactionTrendChart";
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars'
import FilesTable from "./FilesTable";
import TrendBarChart from "./TrendBarChart";
import TransactionFilesBlock from "./TransactionFilesBlock";
import ConcessionaireDashboardChart, { Legends } from "./ConcessionaireDashboardChart";
import { toast } from "react-toastify";
import EntryPointsCharts from "./EntryPointsCharts";
import TnxVsVioVsChargback from "./TnxVsVioVsChargback";
import { UserContext } from '../../contexts/UserContext';

export default function ConcessionaireDashboard() {

  const userDetail = useContext(UserContext);
  const [tollPlazaData, setTollPlaza] = useState([]);
  const [startDate, setStartDate] = useState( getCurrentWeekDate(0).split(" - ")[0]);
  const [endDate, setEndDate] = useState( getCurrentWeekDate(0).split(" - ")[1]);
  const [jsonData, setjsonData] = useState(getJsonData(userDetail));
  const [selectedPlazaOpt, setSelectedPlazaOpt] = useState([]);
  const [laneWisePlaza, setLaneWisePlaza] = useState("");
  const [lane, setLane] = useState("");
  const [triggerBarChartApi, setTriggerBarChartApi] = useState("");
  const [chartData, setChartData] = useState({ totalCase: 0, totalAmt: 0, data:[]});
  const [plaza, setPlaza] = useState("");
  const [rejectionChartData, setRejectionChartData] = useState({
    totalCount: 0, data: [],loader:false
  })

  useEffect(() => {
  if(userDetail?.plaza!==null && userDetail?.plaza!==""){
    const plazaId = userDetail.plaza.join(",");
    const requestBody = { plaza: plazaId };
    getPlaza(requestBody).then(res => {
       const transformed = res.data.map(({ plazaId, plazaName, distanceBased }) => ({ value: plazaId, label: plazaId + "-" + plazaName.toLowerCase(),name: plazaId + "-" + plazaName.toLowerCase(), distanceBased }));
       transformed.sort((a,b)=>a.value - b.value);
        transformed.unshift({ label: "All", value: "*" });
        setPlaza(transformed.map(e=>e.value).join(","));
        setTollPlaza(transformed);
    }).catch(err => {
      toast.warning("Plaza data not found");
    });
    }else{
    console.log("empty user details");
    }
}, [userDetail])

useEffect(() => {
  if(tollPlazaData.length)
  getConsessionerData();
}, [tollPlazaData])


  const setDate = (dates) => {
    if(dates[0]){
      setStartDate(dates[0]);
      setEndDate(dates[1]);
    }
  }

  // Transaction block state
  const [transactionBlock, settransactionBlock] = useState({isLoading:false});
  const [transDateWise, setTransDateWise] = useState([]);
  const [transactionAmtData, setTransactionAmtData] = useState({isLoading:false});
  const [acceptedAmtData, setAcceptedAmtData] = useState([]);

  // Second row grid data
  const [transactionResponceData, setTransactionResponceData] = useState({sent:0,receive:0})
  const [transExcepResData, setTransExcepResData] = useState({resonsetime:"",data:{sent:0,receive:0}});
  const [selectedUser, setSelectedUser] = useState("")
  const [initData, setInItData] = useState({loading:false,data:{}});
  const [cashTransactionData, setCashTransactionData] = useState({loading:false,data:{}});
  const [manualTransactionData, setManualTransactionData] = useState({loading:false,data:{}});
  const [ackNackData, setAckNackData] = useState({loading:false,data:{}});

  useEffect(() => {
    const data = tollPlazaData.filter(e=>plaza.includes(e.value) && e.value !== "*")
    setSelectedPlazaOpt(data);
    setLane("");
    setLaneWisePlaza(data[0] || "");
  }, [plaza, tollPlazaData])

  const [laneOpts, setLaneOpts] = useState([]);

  // LineChart data 4th row ;
  const [transcationTrendByStatus, setTranscationTrendByStatus] = useState({loading:false,data:[]})
  const [transcationVsViolation, setTranscationVsViolation] = useState({loading:false,data:[]});
  const [transVsVioRawData, setTransVsVioRawData] = useState({});
  let txn_vio_list = [
    { name: "Transaction Vs Violation", value: "TV" },
    { name: "Transaction Vs Blacklist", value: "TB" }
  ];

  let trns_list = [
    { name: "Violation", value: "Violation" },
    { name: "Txn vs Blocklist", value: "TB" }
  ];

  let time_slot_list = [
    { name: "Time slot", value: "Time slot" },
    { name: "Txn vs Blocklist", value: "TB" }
  ];
  const [filterDropdown, setfilterDropdown] = useState("TV");


  //5th row horizontal bar chart
  const [transcationTrendByTimeSlot, setTranscationTrendByTimeSlot] = useState({loading:false,data:[]});
  const [vioPendingDueData, setVioPendingDueData] = useState({data:{},loader:false});
  const [chargeBackData, setChargeBackData] = useState({data:{},loader:false});

  // 7th row files widgets
 const [threeTollFiles, setThreeTollFiles] = useState({loader:false,data:[]});
 const [threeBTLFiles, setThreeBTLFiles] = useState({loader:false,data:[]});
 const [threeDiscountFiles, setThreeDiscountFiles] = useState({loader:false,data:[]});


  useEffect(() => {
    setData([],jsonData,"COUNT");
    setData([],jsonData,"AMOUNT");
  }, [])


  const getConsessionerData =() => {
    setData([],jsonData,"COUNT");
    setData([],jsonData,"AMOUNT");
    if(!plaza && !startDate) return;
    // If plaza is an array, join it to a comma-separated string
    const plazaIds = Array.isArray(plaza) ? plaza.join(",") : plaza; 
    jsonData.plazaIds = plazaIds;
    jsonData.startDate = moment(startDate).format("YYYY-MM-DD");
    jsonData.endDate = moment(endDate).format("YYYY-MM-DD");
    getTransactionBlockData(jsonData);
    getTranscationAmtBlockData(jsonData);
    getTransDateWiseData(jsonData);
    getINITFileTableData(jsonData);
    getCashManualData(jsonData);
    getAckNackFileData(jsonData);
    getTranAcceptedAmtDateWiseData(jsonData);
    getChartsData(jsonData);
    getRejectionChartData(jsonData);
    getTranResTableData(jsonData);
    getTranResExceptionTableData(jsonData);
    getTranscationTrendByTimeSlot(jsonData);
    getLastThreeTollFilesData(jsonData);
    getLastThreeBTLFilesData(jsonData);
    getLastThreeDiscountFilesData(jsonData);
    if(!plaza) return;
    getTranscationTrendByStatus(plazaIds);
    getVioPedingandDueData(plazaIds);
    getChargeBackPendingDueData(jsonData);
    getTranscationVsViolations(plazaIds, filterDropdown);
    getLaneWiseData(jsonData);
    setLane("");
    setTriggerBarChartApi((new Date()).getTime());
  }

  useEffect(() => {
    if(transVsVioRawData.transactionTrend)
    formatDataForLineChart2(transVsVioRawData,filterDropdown)
  }, [filterDropdown])


  //-------------------------------------------------------------------------------------------------------------
  // Funtion to get Transaction Data for 1st row
  const getTransactionBlockData = (jsonData) => {
    settransactionBlock({
      acceptedCount: 0,
      acceptedAmt: 0,
      rejectdeCount: 0,
      rejectdeAmt: 0,
      isLoading: true
    });
    getTransactionData(jsonData).then((res) => {
      const json = {
        acceptedCount: 0,
        acceptedAmt: 0,
        rejectdeCount: 0,
        rejectdeAmt: 0,
        isLoading: false
      };
      const accepted = res.data.filter((e) => e.remarks === 'ACCEPTED')[0];
      json.acceptedCount = accepted.cases;
      json.acceptedAmt = accepted.sumAmount;
      const rejected = res.data.filter((e) => e.remarks !== 'ACCEPTED');

      for (let i = 0; i < rejected.length; i++) {
        const rowdata = rejected[i];
        json.rejectdeCount += rowdata.cases;
        json.rejectdeAmt += rowdata.sumAmount;
      }
      settransactionBlock(json);
    }).catch(err => {
      settransactionBlock({
        acceptedCount: 0,
        acceptedAmt: 0,
        rejectdeCount: 0,
        rejectdeAmt: 0,
        isLoading: false
      });
    })
  };

  // function to get Transaction Amount Data
  const getTranscationAmtBlockData = (jsonData) =>{
    setTransactionAmtData({
        cleanAcceptedAmt:0,
        returnDiscountAmt:0,
        isLoading: true
    })
    getTransactionAmountData(jsonData).then(res =>{
      const cleanAccepted = res.data.filter((e) => e.status === 'cleanAccepted')[0] || {sumAmount:0};
      const returnDiscount = res.data.filter((e) => e.status === 'returnDiscount')[0] || {sumAmount:0};
       const json = {
        cleanAcceptedAmt:cleanAccepted.sumAmount,
        returnDiscountAmt:returnDiscount.sumAmount,
        isLoading: false
       }
      setTransactionAmtData(json);
    }).catch(err => {
      setTransactionAmtData({
        cleanAcceptedAmt:0,
        returnDiscountAmt:0,
        isLoading: false
    });
    });
  }

  //-------------------------------------------------------------------------------------------------------------
  // get Date wise data in first row.
  const getTransDateWiseData = (jsonData) => {
    getTransactionDateWiseData(jsonData).then(response => {
      setData(response.data,jsonData,"COUNT")
    }).catch(_err=>{
      setData([],jsonData,"COUNT")
    });
  }

  // get Date wise Accepted Amount data in first row.
  const getTranAcceptedAmtDateWiseData = (jsonData) => {
    getTransactionAmountDateWiseData(jsonData).then(response => {
      setData(response.data,jsonData,"AMOUNT")
    }).catch(_err=>{
      setData([],jsonData,"AMOUNT")
    });
  }

  const setData = (data,jsonData,type)=>{
    let endDate = jsonData.endDate?.replace("T23:59:59.00Z","");
    endDate +="T23:59:59.00Z"
    let daysArr = getLastNDayArr(endDate,5,"days","YYYY-MM-DD")
    let transDateWiseData = [];
    let arr =[];
    daysArr.forEach(e=>{
      let x =  data.filter(d=> d.date === e)[0];
        arr.push({
             "date": (x ? x.date : e),
             "cases": (x ? x.cases : 0),
             "sumAmount": x ? x.sumAmount : 0
           })
     })
    arr.pop()
    for (let i = 1; i < arr.length; i++) {
      transDateWiseData.push(compareDateWiseData(arr[i-1] || {cases:0,sumAmount:0}, arr[i]));
    }
    if(type === 'COUNT')
     setTransDateWise(transDateWiseData)
    else
     setAcceptedAmtData(transDateWiseData)
  }

  //----Get INIT File data
   const getINITFileTableData = (jsonData) =>{
    setInItData({loading:true,data:{}});
    getINITFileData(jsonData).then(response => {
      const json = {
        fileName: response.data[0].fileName,
        date:response.data[0].date.split(" ")[0],
        time:response.data[0].date.split(" ")[1],
        noOfRecords:response.data[0].noOfRecords
      }

      // setFileName(response.data.map(each => each.fileName).join("/"));

      setInItData({loading:false,data:json});
    }).catch(_err => {
      setInItData({loading:false,data:{}});
    });
   }

   //----Get Cash & Manual data
      const getCashManualData = (jsonData) =>{

       setCashTransactionData({loading:true,data:{}});

       setManualTransactionData({loading:true,data:{}});

       getCashManualTransactionData(jsonData).then(response => {
       var cashJson={
                     cashManual: "0",
                     cases:"0",
                     cashManualCases:"0"
                    };
       var manualJson={
                       cashManual: "0",
                       cases:"0",
                       sumAmount:"0"
                      };


         if(response && response.data && response.data.length>0){
            var dataLength = response.data.length;

            var cCount = 0;
            var cmCount = 0;
            var mTotalCount = 0;
            var mAcceptCount = 0;
            var mRejectCount = 0;
            var mAcceptAmt = 0;
            for(var i=0;i<dataLength;i++){

                if(response.data[i].cashManual === "C"){

                cCount = cCount + parseInt(response.data[i].cases);
                cmCount = cmCount + parseInt(response.data[i].cases);
                    cashJson = {
                                 cashManual: response.data[i].cashManual,
                                 cases:cCount,
                                 cashManualCases:0
                                }
                }else if(response.data[i].cashManual === "M"){

                    if(response.data[i].status === "ACCEPT"){
                        mAcceptCount = mAcceptCount + parseInt(response.data[i].cases);
                        cmCount = cmCount + parseInt(response.data[i].cases);
                        mAcceptAmt = mAcceptAmt + parseFloat(response.data[i].sumAmount);
                    }else{
                        mRejectCount = mRejectCount + parseInt(response.data[i].cases);
                        cmCount = cmCount + parseInt(response.data[i].cases);
                    }
                    mTotalCount = mAcceptCount+mRejectCount;

                    manualJson = {
                                 totalCount: mTotalCount,
                                 acceptCases:mAcceptCount,
                                 rejectCases:mRejectCount,
                                 sumAmount:mAcceptAmt
                                }
                }
            }
            cashJson.cashManualCases = cmCount;
         }
         // setFileName(response.data.map(each => each.fileName).join("/"));

         setCashTransactionData({loading:false,data:cashJson});
         setManualTransactionData({loading:false,data:manualJson});
       }).catch(_err => {
         setCashTransactionData({loading:false,data:{}});
       });
      }




   //----Get ACK/NACK File Data
   const getAckNackFileData = (jsonData) => {
    setAckNackData({loading:true,data:{}});
    getAckNackFilesData(jsonData).then(res => {
     const json = {
      totalFile:numberWithCommas(+res.data[0].ackCount + +res.data[0].nackCount || 0),
      ackCount:numberWithCommas(res.data[0].ackCount || 0),
      nackCount:numberWithCommas(res.data[0].nackCount || 0),
     }
     setAckNackData({loading:false,data:json});
    }).catch(_err => {
      setAckNackData({loading:false,data:{}});
    });
   }


  //-------------------------------------------------------------------------------------------------------------
  // Consessioner Chart Data
  const getChartsData = (jsonData) => {
    setChartData({ totalCase: 0, totalAmt: 0, data:[],loader:true});
    setRejectionChartData({ totalCount: 0, data: [],loader:true})
    getConsessionerChartData(jsonData).then(res => {
      let json = {
        totalCase: res.data.length > 0 ? res.data.map(e => e.cases).reduce((a, v) => a + v) : 0,
        totalAmt: res.data.length > 0 ? res.data.map(e => e.sumAmount).reduce((a, v) => a + v).toFixed(2) : 0,
        data: res.data,
        loader:false
      }
      setChartData(json);
    }).catch(_err=>{
      setChartData({ totalCase: 0, totalAmt: 0, data:[],loader:false});
    })
  }

  //-------------------------------------------------------------------------------------------------------------
  // Transaction Response Data
  const getTranResTableData = (jsonData) => {
    setTransactionResponceData({sent:0,receive:0});
    getTransactionResponseData(jsonData).then(res => {
      const json={
        sent:res.data[0].cases,
        receive:res.data[1].cases
      }
      setTransactionResponceData(json);
    }).catch(_err=>{
      setTransactionResponceData({sent:0,receive:0});
    })
  }

  // Transaction Exception Response Data
  const getTranResExceptionTableData = (jsonData) => {
    setTransExcepResData({resonsetime:"",data:{sent:0,receive:0}});
    getTransactionExceptionResponseData(jsonData).then(res => {
      let json={
        resonsetime: moment().format("DD/MM/YYYY, HH:mm:ss"),
        data:{
          sent:res.data[0].cases,
          receive:res.data[1].cases
        }
      }
      setTransExcepResData(json);
    }).catch(_err=>{
      setTransExcepResData({resonsetime:"",data:{sent:0,receive:0}});
    })
  }

  // Rejection chart Data
  const getRejectionChartData = (jsonData) => {
    getRejectionByReasoneData(jsonData).then(res => {
      setRejectionChartData({
        totalCount: res.data.reduce((acc, curr) => acc + curr.cases, 0),
        data: res.data,
        loader:false
      })
    }).catch(_err=>{
      setRejectionChartData({ totalCount: 0, data: [],loader:false})
    })
  }


  //-------------------------------------------------------------------------------------------------------------
  //line chart data for 4th row 1st widgets

  // const mS = ['','January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const mS = ['','Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  const getTranscationTrendByStatus = (plaza)=> {
    setTranscationTrendByStatus({loading:true,data:[]})
    getTransactionTrendByStatusData(plaza).then(res=>{
      const data = []
      const montharr = getLastNDayArr(new Date(),6,"months",'MM');
      montharr.forEach(m=>{
        const acceptedData = res.data.filter(e=> e.month === +m && e.status?.includes("ACCEPTED"))
        const rejectdeData = res.data.filter(e=> e.month === +m && !e.status?.includes("ACCEPTED"))
        let json = { month:mS[+m],accepted_amt:0,accepted_count:0,rejected_amt:0,rejected_count:0 }

        if(acceptedData.length > 0){
          acceptedData.forEach(e=>{
            json.accepted_amt += e.sumAmount
            json.accepted_count += e.cases
          })
        }
        if(rejectdeData.length > 0){
          rejectdeData.forEach(e=>{
            json.rejected_amt += e.sumAmount
            json.rejected_count += e.cases
          })
        }
        data.push(json);
      })
      setTranscationTrendByStatus({loading:false,data:data  })
    }).catch(err=>{
      setTranscationTrendByStatus({loading:false,data:[]})
    })
  }

   //-------------------------------------------------------------------------------------------------------------
  //line chart data for 4th row 2nd widgets

  const formatDataForLineChart2 = (rawData,filterDropdown) => {
    const transactiondata = rawData.transactionTrend.map(e=>{
      e.status = "transaction"
      return e;
    })
    let vsData = [];
    if(filterDropdown==='TV' && rawData.violationTrend)
        vsData = rawData.violationTrend.map(e=>{
        e.status = "violation"
        return e;
      })
    else if(filterDropdown==='TB' && rawData.blacklistedTrend)
        vsData = rawData.blacklistedTrend?.map(e=>{
        e.status = "blacklisted"
        return e;
      })
    const rawData1 = [...transactiondata,...vsData]
    const data = []
      const montharr = getLastNDayArr(new Date(),6,"months",'MM');
      montharr.forEach(m=>{
        const trancationdData = rawData1.filter(e=> e.month === +m && e.status === "transaction")
        const violationData = rawData1.filter(e=> e.month === +m && e.status !== "transaction")
        let json = { month:mS[+m],transcation_amt:0,transcation_count:0,violation_amt:0,violation_count:0 }

        if(trancationdData.length > 0){
          trancationdData.forEach(e=>{
            json.transcation_amt += e.sumAmount
            json.transcation_count += e.cases
          })
        }
        if(violationData.length > 0){
          violationData.forEach(e=>{
            json.violation_amt += e.sumAmount
            json.violation_count += e.cases
          })
        }
        data.push(json);
      })
    setTranscationVsViolation({loading:false,data:Object.values(data)  })
  };

 //line chart api call for 4th row 2nd widgets
  const getTranscationVsViolations = (plaza,filterDropdown)=> {
    setTranscationVsViolation({loading:true,data:[]})
    getTransactionVsViolationsData(plaza).then(res=>{
    setTransVsVioRawData(res.data)
    formatDataForLineChart2(res.data,filterDropdown)
    }).catch(err=>{
      setTranscationVsViolation({loading:false,data:[]})
    })
  }

   //-------------------------------------------------------------------------------------------------------------

   // Violation Pending and Due data for 5th row
   const getVioPedingandDueData = (plaza)=>{
    setVioPendingDueData({loader:true, data:{}});
    getViolationPendingDueData(plaza).then((res)=>{
      setVioPendingDueData({loader:false, data:(res.data || {})});
    }).catch(()=>{
      setVioPendingDueData({loader:false, data:{}});
    })
   }

   const getChargeBackPendingDueData = (headerJson) => {
    setChargeBackData({loader:true, data:{}});
    fetchChargeBackPendingDueData(headerJson).then((res) => {
      setChargeBackData({loader:false, data:(res.data || {})});
    }).catch(() => {
      setChargeBackData({loader:false, data:{}});
    })
   }

  //line chart data for 5th row
  const getTranscationTrendByTimeSlot = (headerJson)=> {

    setTranscationTrendByTimeSlot({ loading: true, data: [] });
    getTransactionTrendByTimeSlotData(headerJson)
      .then((res) => {
        const data = res.data.filter((e) => ["VC4", "VC5", "VC10", "VC13", "VC20"].includes(e.vehicleClass) );
        const final = data.reduce(
          (acc, val) => {
            if (val.hour < 8) acc["00-08"].push(val);
            else if (val.hour < 16) acc["08-16"].push(val);
            else acc["16-00"].push(val);
            return acc;
          },
          { "00-08": [], "08-16": [], "16-00": [] }
        );
        let finalData = [];
        for (let key of Object.keys(final)) {
          const slotWiseData = final[key].reduce((acc, val) => {
            let vcclass = val.vehicleClass;
            acc.axis = key;
            if (acc[vcclass]) acc[vcclass] += val.cases;
            else acc[vcclass] = val.cases;
            return acc;
          }, {});
          finalData.push(slotWiseData);
        }
        setTranscationTrendByTimeSlot({ loading: false, data: finalData });
      })
      .catch((err) => {
        setTranscationTrendByTimeSlot({ loading: false, data: [] });
      });
  };

  // Table data for Last 3 Toll Files
  const getLastThreeTollFilesData = (jsonData) => {
    setThreeTollFiles({loader:true,data:[]});
    getLastThreeTollFiles(jsonData).then((res)=>{
      setThreeTollFiles({loader:false,data:res.data});
    }).catch((err)=>{
      setThreeTollFiles({loader:false,data:[]});
    });
  }

  // Table data for BTL Files
  const getLastThreeBTLFilesData = (jsonData) => {
    setThreeBTLFiles({loader:true,data:[]});
    getLastThreeBTLFiles(jsonData).then((res)=>{
      setThreeBTLFiles({loader:false,data:res.data});
    }).catch((err)=>{
      setThreeBTLFiles({loader:false,data:[]});
    });
  }

  // Table Data for Discount Files
  const getLastThreeDiscountFilesData = (jsonData) => {
    setThreeDiscountFiles({loader:true,data:[]});
    getLastThreeDiscountFiles(jsonData).then((res)=>{
      setThreeDiscountFiles({loader:false,data:res.data});
    }).catch((err)=>{
      setThreeDiscountFiles({loader:false,data:[]});
    });
  }

  // 8th row Violation table data
  const violationtabledata = [
    { txnid: "ENU9786543235", rrtime:"02/04/2022, 12:34:23", senttobanktime: "02/04/2022, 12:34:23" },
    { txnid: "ENU9786543235", rrtime:"02/04/2022, 12:34:23", senttobanktime: "02/04/2022, 12:34:23" },
    { txnid: "ENU9786543235", rrtime:"02/04/2022, 12:34:23", senttobanktime: "02/04/2022, 12:34:23" }
  ]

  // Lane Wise Transaction Trend data
  const [laneWiseTransChartData, setLaneWiseTransChartData] = useState([]);
  const [laneWiseTransChartFilteredData, setLaneWiseTransChartFilteredData] = useState([]);
  const [laneWiseLoader, setLaneWiseLoader] = useState(false);

  const getLaneWiseData = async (jsonData) => {
    const json = {...jsonData}
    json.plazaIds = laneWisePlaza?.value || laneWisePlaza
    setLaneWiseLoader(true);
    try{
      const {data} = await getLaneWiseTransactionData(json);
      setLaneWiseTransChartData(data)
      setLaneWiseTransChartFilteredData(data);
      setLaneWiseLoader(false)
     const laneIds = data.map(e=> e.laneId?.replace(/[a-zA-Z ]/g,"") || 0);
     const max = Math.max(...laneIds);
     const laneRange =  [{ name: "Lane 1 - 10", value: "1-10"}]

     if(max>10)
     laneRange.push({ name: "Lane 11 - 20", value: "11-20"})
     if(max>20)
     laneRange.push({ name: "Lane 21 - 30", value: "21-30"})
     if(max>30)
     laneRange.push({ name: "Lane 31 - 40", value: "31-40"})
     setLaneOpts(laneRange);
    }catch(err) {
      setLaneWiseLoader(false)
    }
  }

  useEffect(() => {
    getLaneWiseData(jsonData);
  }, [laneWisePlaza])

  useEffect(() => {
    const data = laneWiseTransChartData.filter(e=> {
      const [from,to] = lane.split('-');
      const val = e.laneId?.replace(/[a-zA-Z ]/g,"") || 0
      return from <= +val && to >= +val
    })
    setLaneWiseTransChartFilteredData(data);
  }, [lane])


  // Distance Based Plaza
  let distancePlaza = tollPlazaData.filter(e => e.distanceBased  && e.distanceBased !== 'Point Plaza');

  return (
    <div className="consessioner-dash-page">
      <div className="header-block">
        <div className="flex header-title">
          <p>Dashboard</p>
          <div className="header-action-bar">
          <div style={{display:'flex',justifyContent:'space-between'}}>
          <div className="plazzalov">
          <MultiSelect
              options={tollPlazaData}
              onChange={setPlaza}
              selectedValue={plaza}
              placeHolderName={"Plaza"}
            />
          </div>
          <div>&nbsp;</div>
        <div style={{width:230}}>
          <DateRangePickerComponent
                        startDate={startDate}
                        endDate={endDate}
                        format="MM/dd/yyyy"
                        placeHolderName={"Select Date"}
                        onChange={(e) => setDate(e.target.value)} />
            </div>
          </div>
        <div><button className="go-btn" onClick={getConsessionerData}>Go</button></div>
         </div>
        </div>
      </div>

      <div className="flex-row trans-blocks-container">
        <div>
          <TransactionBlock
            backgroundColor={"blockonecolor"}
            label={"Total Transaction Count"}
            count={transactionBlock.acceptedCount + transactionBlock.rejectdeCount}
            acceptedStatus={"Accepted"}
            rejectedStatus={"Rejected"}
            tracAcceptedCount={transactionBlock.acceptedCount}
            tracRejectedCount={transactionBlock.rejectdeCount}
            transDateWise={transDateWise}
            loader={transactionBlock.isLoading}
            fractionalDigit={0}
          />
        </div>
        <div style={{ maxWidth: 17 }}></div>
        <div>
          <TransactionBlock
            backgroundColor={"blocktwocolor"}
            label={"Total Accepted Amount"}
            count={(transactionAmtData.cleanAcceptedAmt + transactionAmtData.returnDiscountAmt).toFixed(2)}
            acceptedStatus={"Single Journey"}
            rejectedStatus={"Return/Discount"}
            tracAcceptedCount={transactionAmtData.cleanAcceptedAmt?.toFixed(2)}
            tracRejectedCount={transactionAmtData.returnDiscountAmt?.toFixed(2)}
            transDateWise={acceptedAmtData}
            showRupee={true}
            loader={transactionAmtData.isLoading}
            fractionalDigit={2}
          />
        </div>
      </div>
      <div className="flex-row table-widgets">
        <div>
          <TransactionFilesBlock
            tableHeader={"Last INIT File"}
            label={["File Name", "Date","Time","No. of Records"]}
            loader={initData.loading}
            data={[initData.data.fileName || "--",initData.data.date? moment(initData.data.date).format('DD/MM/YYYY'): "--", initData.data.time?initData.data.time:'--', numberWithCommas(initData.data.noOfRecords || 0)]}
          />
        </div>
        <div style={{ maxWidth: 17 }}></div>
        <div>
          <TransactionFilesBlock
          tableHeader={"TOL Files Status"}
          label={["Total Files Sent To Bank","ACK files","NACK files"]}
          loader={ackNackData.loading}
          data={[ackNackData.data.totalFile, ackNackData.data.ackCount, ackNackData.data.nackCount]}
          />
        </div>
      </div>
      <div className="flex-row table-widgets">
          <div>
            <TransactionFilesBlock
              tableHeader={"Cash & Manual Transactions"}
              label={["Cash Count","Manual Count","Total Count"]}
              loader={cashTransactionData.loading}
              data={[cashTransactionData.data.cases || "0", manualTransactionData.data.totalCount || "0",cashTransactionData.data.cashManualCases || 0]}
            />
          </div>
          <div style={{ maxWidth: 17 }}></div>
          <div>
            <TransactionFilesBlock
            tableHeader={"Manual Transactions"}
            label={["Total Count","Accepted Count","Rejected Count","Accepted Amount"]}
            loader={manualTransactionData.loading}
            data={[manualTransactionData.data.totalCount || "0",manualTransactionData.data.acceptCases || "0", manualTransactionData.data.rejectCases || "0", manualTransactionData.data.sumAmount || "0"]}
            />
          </div>
      </div>
      {/* <div className="flex-row table-widgets">
        <div>
          <TransactionTableBlock
            tableHeader={"Transaction Response"}
            data={transactionResponceData}
            dataFooter={"NPCI Based Data"}
          />
        </div>
        <div style={{ maxWidth: 17 }}></div>
        <div>
          <TransactionTableBlock
            tableHeader={"Query/Exception Response"}
            data={transExcepResData.data}
            dataFooter={"Last response time "+transExcepResData.resonsetime}
          />
        </div>
      </div> */}
      <div className="flex-row chart-widgets chart-wrap">
        <div className="chart-wrapper">
          <ConcessionaireDashboardChart
            chartHeader={"Traffic By VC"}
            cartHeaderCount={chartData.totalCase}
            data={chartData.data}
            dataKey={"cases"}
            nameKey={"vehicleClass"}
            loader={chartData.loader}
          />
          <Legends 
            dataKey={"cases"}
            nameKey={"vehicleClass"}
            data={chartData.data}/>
        </div>
        <div className="chart-wrapper">
          <ConcessionaireDashboardChart
            chartHeader={"Revenue By VC"}
            cartHeaderCount={chartData.totalAmt}
            data={chartData.data}
            showRupee={true}
            dataKey={"sumAmount"}
            nameKey={"vehicleClass"}
            loader={chartData.loader}
            fractionalDigit={2}
          />
          <Legends 
            dataKey={"sumAmount"}
            nameKey={"vehicleClass"}
            data={chartData.data}/>
        </div>
        <div className="chart-wrapper">
          <ConcessionaireDashboardChart
            chartHeader={"Rejection By Reason"}
            cartHeaderCount={rejectionChartData.totalCount}
            data={rejectionChartData.data}
            dataKey={"cases"}
            nameKey={"rejectionReason"}
            loader={rejectionChartData.loader}
          />
          <Legends 
            dataKey={"cases"}
            nameKey={"rejectionReason"}
            data={rejectionChartData.data}/>
        </div>
      </div>
      <div className="flex-row line-chart">
        <div className="line-chart-wrapper">
          <p className="block-title">Transaction Trend By Status</p>
          <LineChartComp 
            data={transcationTrendByStatus.data} 
            loader={transcationTrendByStatus.loading} 
            leftYAxisLabel="Rejected Transactions" 
            rightYAxisLabel="Accepted Transactions" 
            xDataKey="month" 
            firstLineDataKey="rejected_count" 
            secondLineDataKey="accepted_count"/>
        </div>
        <div style={{ maxWidth: 17 }}></div>
        <div className="line-chart-wrapper">
          <div className="flex-row">
          <p className="block-title">Transaction Vs Violations</p>
          {/* <div className="AVCfilter trans-vs-vio-filter">
                <SelectSearch
                  options={txn_vio_list}
                  search
                  filterOptions={fuzzySearch}
                  placeholder="Txn vs Violation"
                  value={filterDropdown}
                  onChange={setfilterDropdown}
                  name="adj_type"
                />
              </div> */}
              </div>
          <LineChartComp 
            data={transcationVsViolation.data} 
            loader={transcationVsViolation.loading} 
            leftYAxisLabel="Violation" 
            rightYAxisLabel="Transaction" 
            xDataKey="month" 
            firstLineDataKey="violation_count" 
            secondLineDataKey="transcation_count"/>
        </div>
      </div>
      <div className="flex-row gap-17">
        <div className="violations-block">
        <div className="flex-row">
        <ViolationsChargebackBlock
            Header={"Chargeback"}
            loader={chargeBackData.loader}
            pendingData={chargeBackData.data["chargePending"]}
            dueData={chargeBackData.data["chargeDue"]}
          />
          </div>
           <div className="flex-row">
          <ViolationsChargebackBlock 
            Header={"Violations"}
            loader={vioPendingDueData.loader}
            pendingData={vioPendingDueData.data["violations pending"]}
            dueData={vioPendingDueData.data["violations due"]}
          />
          </div>
        </div>
        <div className="trans-tren-chart">
        <TransactionTrendChart
            tableHeader={"Transaction trend by time slot"}
            data={transcationTrendByTimeSlot.data}
            loader={transcationTrendByTimeSlot.loading}
          />
        </div>
      </div>

      <div>
      <div className="trend-bar-chart-wrapper">
        <div className="flex-row">
        <p className="block-title">Lane Wise Transaction Count Trend</p>
        {/* <div className="flex-row trend_dropdown">
        <SelectSearch
                  options={trns_list}
                  search
                  filterOptions={fuzzySearch}
                  placeholder="Transaction"
                  value={filterDropdown}
                  onChange={setfilterDropdown}
                  name="trans"
                />
                <SelectSearch
                  options={time_slot_list}
                  search
                  filterOptions={fuzzySearch}
                  placeholder="Time Slot"
                  value={filterDropdown}
                  onChange={setfilterDropdown}
                  name="time_slot"
                />
                </div> */}
                <div className="flex-row trend_dropdown">
            <SelectSearch
                options={selectedPlazaOpt}
                search
                filterOptions={fuzzySearch}
                placeholder="Plaza"
                value={laneWisePlaza}
                onChange={setLaneWisePlaza}
                name="distanceBasedPlaza"
              />
              <SelectSearch
                options={laneOpts}
                search
                filterOptions={fuzzySearch}
                placeholder="LaneId"
                value={lane}
                onChange={setLane}
                name="distanceBasedPlaza"
              />
         </div>
        </div>
         <TrendBarChart loader={laneWiseLoader} data={laneWiseTransChartFilteredData}/>
      </div>

      <div className="flex-row gap-17 files-table-block">
        <div>
          <FilesTable
          tableHeader={"Last 3 TOL Files"}
          header={["File Name","Receive Date & Time","Total Txn Count"]}
          data={threeTollFiles.data}
          loader={threeTollFiles.loader}
          dataKey={["file_name", "status_dt", "total_record_count"]}/>
        </div>
        <div>
          <FilesTable
           tableHeader={"Last 3 BLT Files"}
           header={["File Name","Processed/Sent Date & Time","Total Entries/Tags Count"]}
           data={threeBTLFiles.data}
           loader={threeBTLFiles.loader}
           dataKey={["file_name", "status_dt", "total_record_count"]}/>
        </div>
        <div>
          <FilesTable
           tableHeader={"Last 3 DIS Files"}
           header={["File Name","Processed/Sent Date & Time","Total Entries"]}
           data={threeDiscountFiles.data}
           loader={threeDiscountFiles.loader}
           dataKey={["file_name", "status_dt", "total_record_count"]}/>
        </div>
      </div>
      {distancePlaza.length>0 &&
        <EntryPointsCharts 
        jsonData={jsonData}
        tollPlazaData={distancePlaza}   
        />
      }
      <TnxVsVioVsChargback
      selectedPlazaOpt={selectedPlazaOpt}
      triggerBarChartApi={triggerBarChartApi}
      />
      </div>
    </div>
  );
}